import axios from "axios";
import { API_END_POINT } from "../../constants/api";

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const CLEAR_STATE = "CLEAR_STATE";

export function register(userData) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify(userData);
    axios
      .post(`${API_END_POINT}/users/signup`, body, config)
      .then((res) => {
        console.log("response=>", res);

        dispatch({
          type: REGISTER_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: REGISTER_FAIL,
            payload: err.response.data.message,
          });
        }
      });
  };
}
export function clearState() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_STATE,
    });
  };
}
